import { render, staticRenderFns } from "./ArtworkUpload.vue?vue&type=template&id=885f68fe&scoped=true&"
import script from "./ArtworkUpload.vue?vue&type=script&lang=js&"
export * from "./ArtworkUpload.vue?vue&type=script&lang=js&"
import style0 from "./ArtworkUpload.vue?vue&type=style&index=0&id=885f68fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "885f68fe",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VAlert,VProgressCircular})
